/*! Copyright (c) Safe As Milk. All rights reserved. */
class ProductSingle extends HTMLElement {
    #variant;
    connectedCallback() {
        this.mediaGallery = this.querySelector("media-gallery");
        this.#moveModalsFromStickyScrollContainer();
    }
    set variant(variant) {
        this.#variant = variant;
    }
    get variant() {
        return this.#variant;
    }
    #moveModalsFromStickyScrollContainer() {
        const modals = this.querySelectorAll("sticky-scroll modal-dialog, sticky-scroll popup-dialog");
        modals.forEach((modal => {
            this.append(modal);
        }));
    }
}

customElements.define("product-single", ProductSingle);


/**
 * Sticky buy bar
 */
document.addEventListener('DOMContentLoaded', function() {
  const buyBar = document.querySelector('.js-product-form__buy-bar');
  const productAddButton = document.querySelector('.product-form__add > .js-product-add');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!!(buyBar)) {
          if (!entry.isIntersecting && window.scrollY > (document.querySelector('.js-product-buttons').getBoundingClientRect().top + window.scrollY)) {
            buyBar.hidden = false;
            document.body.style.paddingBottom = buyBar.getBoundingClientRect().height + 'px';
          } else {
            buyBar.hidden = true;
          }
        }
      });
    },
    { threshold: 1.0 }
  );

  if (!!(buyBar) && !!(productAddButton)) {
    observer.observe(productAddButton);
  }

  // Shop Pay Installments

  const shopPayInstallmentsObserver = new MutationObserver(() => {
    const shopPayInstallmentsCta = document.querySelector('shopify-payment-terms')?.shadowRoot?.getElementById('shopify-installments-cta');

    if (!!(shopPayInstallmentsCta)) {
      shopPayInstallmentsCta.innerText = 'Learn More';
      shopPayInstallmentsObserver.disconnect();
    }
  });

  shopPayInstallmentsObserver.observe(document.body, { childList: true, subtree: true });

  // Accordion
  // Move accordion below the perfect pairings

  const productSingle = document.querySelector('.js-product-single');

  if (!!(productSingle) && productSingle.offsetWidth <= 996) {
    const accordion = document.querySelector('.js-product-single__box__block--tab');
    const perfectPairings = document.querySelector('.js-product-single__box__block--complementary-products');

    if (!!(accordion) && !!(perfectPairings)) {
      perfectPairings.parentElement.insertBefore(accordion, perfectPairings);
    }
  }
});

//# sourceMappingURL=product-single.js.map
